import { Component, type ErrorInfo, type ReactNode } from 'react'
import './app-error-boundary.css'

type Props = { children: ReactNode }
type State = { error: Error | null; kind: 'chunk' | 'screen' | null }

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null, kind: null }

  static getDerivedStateFromError(error: Error): State {
    return { error, kind: isChunkLoadError(error) ? 'chunk' : 'screen' }
  }

  componentDidCatch(error: Error, _info: ErrorInfo) {
    if (!isChunkLoadError(error)) return
    const recoveryKey = `shared:chunk-recovery:${window.location.pathname}`
    const previousAttempt = Number(window.sessionStorage.getItem(recoveryKey) ?? 0)
    if (Date.now() - previousAttempt < 30_000) return
    window.sessionStorage.setItem(recoveryKey, String(Date.now()))
    window.location.reload()
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <main className="app-recovery" id="main-content">
        <div className="app-recovery__mark">{this.state.kind === 'chunk' ? '↑' : '!'}</div>
        <p className="sh-eyebrow">{this.state.kind === 'chunk' ? 'Atualização pendente' : 'Falha isolada da tela'}</p>
        <h1>{this.state.kind === 'chunk' ? 'A versão da tela mudou' : 'Esta tela encontrou um erro'}</h1>
        <p>{this.state.kind === 'chunk'
          ? 'O Shared tentou atualizar uma vez. Se a tela continuar aqui, recarregue manualmente sem repetir a operação anterior.'
          : 'Nenhuma ação foi repetida. Volte para aplicações ou recarregue esta tela para tentar novamente.'}</p>
        <div>
          <button type="button" onClick={() => window.location.reload()}>Recarregar</button>
          <button type="button" onClick={() => { window.location.href = '/apps' }}>Voltar para aplicações</button>
        </div>
      </main>
    )
  }
}

function isChunkLoadError(error: Error): boolean {
  return /dynamically imported module|loading chunk|chunkloaderror|importing a module script/i.test(error.message)
}
